const select = (element) => document.querySelector(element);
const selectAll = (element) => document.querySelectorAll(element);

document.addEventListener('DOMContentLoaded', () => {
    // Modal lateral (modal-select-city)
    showHiddenLi(
        '.input-select-city',
        '#modal-select-city .city-item',
        'data-city',
        '#modal-select-city.no-slug .body-card',
        '#modal-select-city.no-slug .close-modal',
        '#modal-select-city.no-slug'
    );

    // Modal centralizado (modal-city-selection-center)
    showHiddenLi(
        '.input-select-city-empty',
        '#modal-city-selection-center .city-item',
        'data-city-empty',
        '#modal-city-selection-center .body-card',
        '#modal-city-selection-center .close-modal',
        '#modal-city-selection-center'
    );
});

function showHiddenLi(inputSelect, itemCity, dataCity, bodyCardSelector, closeModalSelector, modalSelector) {
    const input = select(inputSelect);
    if (!input) return;

    input.addEventListener('focus', () => select(bodyCardSelector)?.classList.add('active'));
    input.addEventListener('focusout', () => setTimeout(() => select(bodyCardSelector)?.classList.remove('active'), 300));
    select(closeModalSelector)?.addEventListener('click', () => select(modalSelector)?.classList.remove('show', 'no-slug'));

    input.addEventListener("keyup", () => {
        selectAll(itemCity)?.forEach(city => {
            if (!city.getAttribute(dataCity).toLowerCase().includes(input.value.toLowerCase()))
                city.classList.remove('show');
            else
                city.classList.add('show');
        });
    });
}
